import React from 'react';

function CardIcon({ className = '' }) {
	let fillColor = className.includes('active') ? '#212121' : '#9E9E9E';

	return (
		<svg
			width='22'
			height='17'
			viewBox='0 0 22 17'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M19.125 0H2.125C0.945624 0 0.010625 0.945624 0.010625 2.125L0 14.875C0 16.0543 0.945624 17 2.125 17H19.125C20.3043 17 21.25 16.0543 21.25 14.875V2.125C21.25 0.945624 20.3043 0 19.125 0ZM19.125 14.875H2.125V8.49999H19.125V14.875ZM19.125 4.24999H2.125V2.125H19.125V4.24999Z'
				fill={fillColor}
			/>
		</svg>
	);
}

export default CardIcon;
